/* eslint-disable max-lines */
import WarningMsg from 'components/WarningMsg';
import React from 'react';
import {
  getActiveLanguageMatcher,
  getActiveLanguageMatcherId,
  getCompareMode,
  getShouldDisableEdit,
  saveIdentifierRequestLoading,
  unsavedChanges,
} from 'selectors/identifier';
import { useSelector } from 'store';
import { languageMatcherNotificationMsgs } from 'utils/userNotificationMsgs';
import DeleteMatcherButton from '../DeleteMatcherButton';
import LanguageMatcherHeader from '../LanguageMatcherHeader';
import ListFieldWithImport from '../shared/ListFieldWithImport';

type Props = { isSaved: boolean };

const MetadataSenderForm: React.FC<Props> = ({ isSaved }) => {
  const unsaved = useSelector(unsavedChanges);
  const isLoadingSaveIdentifier = useSelector(saveIdentifierRequestLoading);
  const compareMode = useSelector(getCompareMode);
  const shouldDisable = useSelector(getShouldDisableEdit);
  const activeLanguageMatcher = useSelector(getActiveLanguageMatcher);
  const activeLanguageMatcherId = useSelector(getActiveLanguageMatcherId);

  return (
    <div className="flex flex-col pt-5 pl-10 pr-4 pb-6 text-body h-full">
      <div className="flex flex-row justify-end">
        <WarningMsg
          message={languageMatcherNotificationMsgs.unsavedChanges}
          showLoading={isLoadingSaveIdentifier}
          showWarning={unsaved}
          showSavedMsg={isSaved}
        />
      </div>

      <div className="-mt-4 flex flex-col gap-4 text-body h-full">
        <LanguageMatcherHeader />

        <div className="mt-6 flex flex-col gap-4">
          <ListFieldWithImport
            label="Domains to match"
            languageMatcherId={activeLanguageMatcherId}
            parentType="metadata_sender"
            // @ts-ignore
            field="domains"
            // @ts-ignore
            value={(activeLanguageMatcher.domains as string[]) || []}
            compareMode={compareMode}
            shouldDisable={shouldDisable}
          />

          <ListFieldWithImport
            label="Top level domains to match"
            helperText={`e.g. com, gov, edu, io. (Don't include the dot ".")`}
            languageMatcherId={activeLanguageMatcherId}
            parentType="metadata_sender"
            // @ts-ignore
            field="tlds"
            // @ts-ignore
            value={(activeLanguageMatcher.tlds as string[]) || []}
            compareMode={compareMode}
            shouldDisable={shouldDisable}
          />

          <ListFieldWithImport
            label="Exact email address to match"
            languageMatcherId={activeLanguageMatcherId}
            parentType="metadata_sender"
            // @ts-ignore
            field="emails"
            // @ts-ignore
            value={(activeLanguageMatcher.emails as string[]) || []}
            compareMode={compareMode}
            shouldDisable={shouldDisable}
          />

          <div className="mt-10">
            <ListFieldWithImport
              label="Enable for users in Team (UUIDs)"
              languageMatcherId={activeLanguageMatcherId}
              parentType="metadata_sender"
              // @ts-ignore
              field="teams"
              // @ts-ignore
              value={(activeLanguageMatcher.teams as string[]) || []}
              compareMode={compareMode}
              shouldDisable={shouldDisable}
              enableImport={false}
            />
          </div>
        </div>

        <div className="mt-auto pt-6 flex flex-row justify-end">
          <DeleteMatcherButton
            text="Delete Matcher"
            setValue={(): void => {
              // moot
            }}
            setHighlightedLanguageMatcher={(): void => {
              // moot
            }}
            activeLanguageMatcher={activeLanguageMatcher}
          />
        </div>
      </div>
    </div>
  );
};

export default MetadataSenderForm;
